export default __webpack_public_path__ + "static/media/faci12.af55d351.jpg";